import { cdataFetch } from "../../../api/cdataFetch";

export async function toggleCacheJob(jobId: string) {
  return cdataFetch({
    method: "PUT",
    url: `/cacheJobs/toggle/${jobId}`,
  });
}
